import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import {
  Illustration,
  PageHeaderWrapper,
  Text,
  Title,
} from "@src/appV2/redesign/system/ui-components";

export interface NoBadgeContentProps {
  isSubmitting: boolean;
  onBack: () => void;
  onClose: () => void;
  onSkipToClockIn: () => void;
}

export function NoBadgeContent(props: NoBadgeContentProps) {
  const { isSubmitting, onBack, onClose, onSkipToClockIn } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow
          hideBackButton
          rightAction={
            <IconButton
              iconType="close"
              variant="outlined"
              disabled={isSubmitting}
              onClick={onClose}
            />
          }
        />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Illustration type="complete-profile" />

        <Stack alignItems="center" textAlign="center" sx={{ paddingX: 2 }}>
          <Title variant="h2" component="h1">
            Forgot your badge at home?
          </Title>

          <Text variant="body1" color={(theme) => theme.palette.text.secondary} marginTop={8}>
            Please ask a workplace employee to print a temporary badge for you to wear this shift.
          </Text>

          <Text variant="body1" color={(theme) => theme.palette.text.secondary} marginTop={4}>
            Next time, make sure to bring your own badge to avoid losing points
          </Text>
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" disabled={isSubmitting} onClick={onBack}>
          I have a badge to wear this shift
        </Button>
        <LoadingButton
          fullWidth
          variant="outlined"
          size="large"
          isLoading={isSubmitting}
          onClick={onSkipToClockIn}
        >
          Skip to clock in
        </LoadingButton>
      </DialogFooter>
    </>
  );
}
